<!--
 * @Description: 
 * @Date: 2022-03-02 18:06:18
-->
<template>
  <div>
    <div
      :style="{ color: !value ? '#c5c5c5' : '' }"
      v-show="!showInput"
      @click="changeShowInput"
    >
      {{ value || '可编辑' }}
    </div>
    <el-input
      size="small"
      v-model="tableRowData[personLabelKey]"
      maxlength="10"
      v-show="showInput"
      ref="input"
      placeholder="请输入标签"
      @blur="showInput = false"
      @input="handleChange"
    ></el-input>
  </div>
</template>

<script>
export default {
  name: 'table-edit-person-label',
  props: {
    tableRowData: {
      type: Object,
      default: () => ({})
    },
    personLabels: {
      type: Object,
      default: () => ({})
    },
    personLabelKey: {
      type: String,
      default: 'inputUserTag'
    },
    localSavePersonLabelKey: {
      type: String,
      default: 'userId'
    }
  },
  data() {
    return {
      showInput: false
    };
  },
  computed: {
    value() {
      const {
        personLabels,
        tableRowData,
        personLabelKey,
        localSavePersonLabelKey
      } = this;
      return (
        tableRowData[personLabelKey] ||
        personLabels[tableRowData[localSavePersonLabelKey]] ||
        ''
      );
    }
  },
  methods: {
    handleChange(value) {
      const {
        personLabels,
        tableRowData,
        localSavePersonLabelKey,
        personLabelKey
      } = this;
      const _value = `${value}`.replace(/,/g, '');
      tableRowData[personLabelKey] = personLabels[
        tableRowData[localSavePersonLabelKey]
      ] = _value;
    },
    changeShowInput() {
      this.showInput = true;
      this.$nextTick(() => {
        this.$refs['input'].focus();
      });
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped></style>
